<template>
    <div data-testid="financialclose_component_inputparameterriskmanagement__root">
      <div class="d-flex" data-testid="financialclose_component_inputparameterriskmanagement__toolbar">
        <v-spacer></v-spacer>
        <v-btn
          v-if="editable"
          class="mb-2 mr-2"
          color="primary"
          @click="saveInputParameters()"
          data-testid="financialclose_component_inputparameterriskmanagement__save-btn"
        ><span>Save Input Parameters</span></v-btn>
      </div>
      <template v-for="(item, i) in parameter">
        <div :key="i" v-if="!item.hidden" :data-testid="`financialclose_component_inputparameterriskmanagement__param-row-${i}`">
          <div class="d-flex pa-2 hoverable align-start" data-testid="financialclose_component_inputparameterriskmanagement__param-panel">
            <span class="mr-4" data-testid="financialclose_component_inputparameterriskmanagement__param-serial">{{ i + 1 }}.</span>
            <div class="" data-testid="financialclose_component_inputparameterriskmanagement__param-title">
              <span class="font-weight-bold" data-testid="financialclose_component_inputparameterriskmanagement__param-code">{{ item.code }}</span>
              <v-icon>mdi-circle-small</v-icon>
              <span data-testid="financialclose_component_inputparameterriskmanagement__param-name">{{ item.name }}</span>
            </div>
            <v-spacer></v-spacer>
            <div style="max-width: 200px" class="mr-4" data-testid="financialclose_component_inputparameterriskmanagement__param-verification-panel">
              <v-chip class="mr-1" label v-for="(v,k) in item.verification" :key="k" :data-testid="`financialclose_component_inputparameterriskmanagement__param-verification-chip-${k}`"><span>{{v.code}}</span></v-chip>
            </div>
            <div data-testid="financialclose_component_inputparameterriskmanagement__param-input-panel">
              <div style="width: 250px">
                <div v-if="item.type === 'number'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-number">
                  <lb-number
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
                <div v-else-if="item.type === 'string'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-string">
                  <lb-string
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
                <div v-else-if="item.type === 'date'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-date">
                  <lb-date v-model="parametervalue[item._id]" :hidedetails="true" :disabled="!editable"/>
                </div>
                <div v-else-if="item.type === 'year'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-year">
                  <lb-year v-model="parametervalue[item._id]" :hidedetails="true" :disabled="!editable"/>
                </div>
                <div v-else-if="item.type === 'month'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-month">
                  <lb-month
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
                <div v-else-if="item.type === 'time'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-time">
                  <lb-time v-model="parametervalue[item._id]" :hidedetails="true" :disabled="!editable"/>
                </div>
                <div v-else-if="item.type === 'daterange'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-daterange">
                  <lb-daterange
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
                <div v-else-if="item.type === 'timerange'" class="parameter-input" data-testid="financialclose_component_inputparameterriskmanagement__param-input-timerange">
                  <lb-timerange
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
                <div
                  v-else-if="
                    [
                      'numberarray',
                      'stringarray',
                      'datearray',
                      'yeararray',
                      'montharray',
                      'timearray',
                      'daterangearray',
                      'timerangearray',
                    ].indexOf(item.type) > -1
                  "
                  class="parameter-input"
                  data-testid="financialclose_component_inputparameterriskmanagement__param-input-list"
                >
                  <lb-list
                    :allowrepeat="true"
                    :type="item.type"
                    v-model="parametervalue[item._id]"
                    :hidedetails="true"
                    :disabled="!editable"
                  />
                </div>
              </div>
            </div>
          </div>
          <v-divider data-testid="financialclose_component_inputparameterriskmanagement__param-divider"></v-divider>
        </div>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      parameter: {
        type: Array,
        required: true,
      },
      parametervalue: {
        type: Object,
        required: true,
      },
      apiParam: {
        type: String,
        required: true,
      },
      editable: {
        type: Boolean,
        default: false,
      },
      // FBC cycle id for bot/analysis fcAccess (botCycleFromBody)
      pid: {
        type: String,
        default: '',
      },
    },
    data() {
      return {};
    },
    methods: {
      saveInputParameters() {
        this.$emit('startloading');
        const pid = this.pid || this.$route.params.id || '';
        let objectInput = { inputparameter: this.parametervalue, pid };
        this.axios
          .post(this.apiParam, {
            pid,
            data: objectInput,
          })
          .then((ele) => {
            if (ele.data.status === "success") {
              this.$store.commit("sbSuccess", "Input Parameters Updated");
              this.$emit('reload');
            } else throw new Error("Error updating input parameters");
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.$emit('stoploading');
          });
      },
      // saveInputParameters() {
      //   console.log(this.apiParam,"apiParam--->",this.parametervalue);
      // },
    },
  };
  </script>